<template>
  <dialogTem :visible.sync="forgetPassword" :diaTitle="$t('header.forget')" :iscolor="'#323232'">
    <div class="step-wrap forgetTab">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane class="input-wrap" :label="$t('forget.RetrieveSMS')" name="first">
          <el-steps :active="phoneActive" finish-status="success">
            <el-step :title="$t('forget.sendMsg')"></el-step>
            <el-step :title="$t('forget.checking')"></el-step>
            <el-step :title="$t('forget.finish')"></el-step>
          </el-steps>
          <div v-if="phoneActive===0" class="verify-warp">
            <el-row>
              <el-col :span="24">
                <el-input
                  @keyup.enter.native="sendPhoneCode"
                  :placeholder="$t('forget.userPlace')"
                  v-model="forgetUserName">
                  <i slot="prefix" class="el-input__icon el-icon-search icon-user"></i>
                </el-input>
              </el-col>
            </el-row>
            <div class="phone-wrap">
              <el-row>
                <el-col :span="24">
                  <div>
                    <el-input
                      @keyup.enter.native="sendPhoneCode"
                      :placeholder="$t('forget.phonePlace')"
                      v-model="forgetUserPhone">
                      <i slot="prefix" class="el-input__icon el-icon-search icon-phone"></i>
                    </el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="button-wrap">
              <el-button class="button btn2" :loading="!haveSendPhoneCode" style="margin-top: 12px;" @click="sendPhoneCode">{{ $t('forget.sendPhoneMsg') }}</el-button>
            </div>
          </div>
          <div v-if="phoneActive===1" class="verify-warp">
            <el-row>
              <el-col :span="24">
                <div>
                  <el-input
                    :placeholder="$t('forget.phonePlace')"
                    disabled
                    v-model="forgetUserPhone">
                    <i slot="prefix" class="el-input__icon el-icon-search icon-phone"></i>
                  </el-input>
                </div>
              </el-col>
            </el-row>
            <div class="phone-wrap">
              <el-row>
                <el-col :span="14">
                  <el-input
                    @keyup.enter.native="verifyPhoneCode"
                   :placeholder="$t('forget.sendEmail')"
                    v-model="phoneUserCode">
                    <i slot="prefix" class="el-input__icon el-icon-search icon-code"></i>
                  </el-input>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content">
                    <el-button @click.native="sendPhoneCode" :loading="phoneSending" size="small" round>{{phoneBtnTips}}
                    </el-button>
                  </div>
                </el-col>
              </el-row>
              <p style="font-size: 12px;padding-bottom: 15px">{{$t('forget.tips2')}}</p>
            </div>
            <el-row>
              <el-col :span="24">
                <el-input
                  @keyup.enter.native="verifyPhoneCode"
                  :placeholder="$t('forget.newpwdPlace')"
                  type="password"
                  v-model="newPassWord">
                  <i slot="prefix" class="el-input__icon el-icon-search icon-user"></i>
                </el-input>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-input
                  @keyup.enter.native="verifyPhoneCode"
                  :placeholder="$t('forget.reNewpwdPlace')"
                  type="password"
                  v-model="repeatNewPassWord">
                  <i slot="prefix" class="el-input__icon el-icon-search icon-user"></i>
                </el-input>
              </el-col>
            </el-row>
            <div class="button-wrap">
              <el-button class="button" style="margin-top: 12px;" @click="verifyPhoneCode">{{ $t('forget.check')}}</el-button>
            </div>
          </div>
          <div v-if="phoneActive===2" class="verify-warp">
            <div class="complete-warp">
              <img :src="completeImg" alt="">
              <span class="tip">{{ $t('forget.celebrate')}}!</span>
              <span>{{ $t('forget.resetSuccess')}}!</span>
            </div>
            <div class="button-wrap">
              <el-button class="button" style="margin-top: 12px;" @click="forgetPassword = false">{{ $t('forget.determine')}}</el-button>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane class="input-wrap" :label="$t('forget.MailboxRetrieve')" name="second">
          <el-steps :active="emailActive" finish-status="success">
            <el-step :title="$t('forget.sendMsg')"></el-step>
            <el-step :title="$t('forget.checking')"></el-step>
            <el-step :title="$t('forget.finish')"></el-step>
          </el-steps>
          <div v-if="emailActive===0" class="verify-warp">
            <el-row>
              <el-col :span="24">
                <el-input
                  @keyup.enter.native="sendEmailCode"
                  :placeholder="$t('forget.userPlace')"
                  v-model="forgetUserName">
                  <i slot="prefix" class="el-input__icon el-icon-search icon-user"></i>
                </el-input>
              </el-col>
            </el-row>
            <div class="phone-wrap">
              <el-row>
                <el-col :span="24">
                  <div>
                    <el-input
                      @keyup.enter.native="sendEmailCode"
                      :placeholder="$t('forget.emailPlace')"
                      v-model="forgetUserEmail">
                      <i slot="prefix" class="el-input__icon el-icon-search icon-email"></i>
                    </el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="button-wrap">
              <el-button class="button btn2" :loading="!haveSendEmailCode" style="margin-top: 12px;" @click="sendEmailCode">{{ $t('forget.sendEmail')}}</el-button>
            </div>
          </div>
          <div v-if="emailActive===1" class="verify-warp">
            <el-row>
              <el-col :span="24">
                <div>
                  <el-input
                    :placeholder="$t('forget.emailPlace')"
                    disabled
                    v-model="forgetUserEmail">
                    <i slot="prefix" class="el-input__icon el-icon-search icon-phone"></i>
                  </el-input>
                </div>
              </el-col>
            </el-row>
            <div class="phone-wrap">
              <el-row>
                <el-col :span="14">
                  <el-input
                    @keyup.enter.native="verifyEmailCode"
                    :placeholder="$t('forget.verifyPlace')"
                    v-model="emailUserCode">
                    <i slot="prefix" class="el-input__icon el-icon-search icon-code"></i>
                  </el-input>
                </el-col>
                <el-col :span="10">
                  <div class="grid-content">
                    <el-button @click.native="sendEmailCode" :loading="emailSending" size="small" round>{{emailBtnTips}}</el-button>
                  </div>
                </el-col>
              </el-row>
              <p style="font-size: 12px;padding-bottom: 15px">{{ $t('forget.tips2') }}</p>
            </div>
            <el-row>
              <el-col :span="24">
                <el-input
                  @keyup.enter.native="verifyEmailCode"
                  :placeholder="$t('forget.newpwdPlace')"
                  type="password"
                  v-model="newPassWord">
                  <i slot="prefix" class="el-input__icon el-icon-search icon-user"></i>
                </el-input>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-input
                  @keyup.enter.native="verifyEmailCode"
                  :placeholder="$t('forget.reNewpwdPlace')"
                  type="password"
                  v-model="repeatNewPassWord">
                  <i slot="prefix" class="el-input__icon el-icon-search icon-user"></i>
                </el-input>
              </el-col>
            </el-row>
            <div class="button-wrap">
              <el-button class="button" style="margin-top: 12px;" @click="verifyEmailCode">{{ $t('forget.check') }}</el-button>
            </div>
          </div>
          <div v-if="emailActive===2" class="verify-warp">
            <div class="complete-warp">
              <img :src="completeImg" alt="">
              <span class="tip">{{ $t('forget.celebrate') }}!</span>
              <span>{{ $t('forget.resetSuccess') }}!</span>
            </div>
            <div class="button-wrap">
              <el-button class="button" style="margin-top: 12px;" @click="forgetPassword = false">{{ $t('forget.determine') }}!</el-button>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane class="input-wrap" :label="$t('forget.CustomerRetrieve')" name="third">
          <a v-if="customer_service_system_link" :href="customer_service_system_link" target="_blank" style="text-decoration: underline;color: red">{{ $t('newHome.online')}} >></a>
        </el-tab-pane>
      </el-tabs>
    </div>
  </dialogTem>
</template>

<script>
import dialogTem from '../dialogTem.vue'
import { check, common, commonApi } from '@/common/index';
import { mapState } from 'vuex';
export default {
  name: 'forgetPassword',
  components:{ dialogTem },
  props: {
    showForgetPassword: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
        customer_service_system_link: state => state.FrontConfigList.customer_service_system_link,
    })
  },
  data() {
    return {
      // 修改密码
      clickModal: false,
      pressEscape: false,
      forgetPassword: false,
      activeName: 'first',

      forgetUserName: '',
      forgetUserPhone: '',
      forgetUserEmail: '',
      phoneUserCode: '',
      emailUserCode: '',

      // 发送手机验证码
      haveSendPhoneCode: true,
      // 验证手机
      haveTestPhoneCode: true,

      // 发送邮箱验证码
      haveSendEmailCode: true,
      // 验证邮箱
      haveTestEmailCode: true,

      newPassWord: '',
      repeatNewPassWord: '',
      completeImg: require('./wave.png'),

      // 手机找回
      phoneActive: 0,
      phoneBtnTips: '再次发送验证码',
      phoneSending: false,
      phoneTimer: '',
      phoneCount: 60,

      emailActive: 0,
      emailBtnTips: '再次发送验证码',
      emailCount: 60,
      emailTimer: '',
      emailSending: false,
    }
  },
  watch: {
    showForgetPassword() {
      if(this.showForgetPassword) {
        this.forgetPassword = true
      }
    },
    forgetPassword() {
      if(this.forgetPassword===false) {
        this.switchDialog();
        // 关闭弹框，重置数据
        this.phoneActive = 0;
        this.emailActive = 0;
        this.activeName = 'first';

        this.newPassWord = '';
        this.repeatNewPassWord = '';

        this.forgetUserName = '';
        this.forgetUserPhone = '';
        this.forgetUserEmail = '';
        this.phoneUserCode = '';
        this.emailUserCode = '';

        this.emailCountDownFinish();
        this.phoneCountDownFinish();
      }
    }
  },
  methods: {
    sendPhoneCode() {
      let params = {
        username: this.forgetUserName,
        numberType: 1,
        phoneOrEmail: this.forgetUserPhone,
      };
      let isOK = this.checkSendPhoneForm()
      if(this.haveSendPhoneCode&&isOK) {
        this.haveSendPhoneCode = false;
        this.phoneSending = true;

        this.$api.post(this.$urls.USER.sendCode, params, (resp) => {
          this.haveSendPhoneCode = true;
          if (resp.data.code === 200) {
            this.phoneActive = 1;
            this.phoneCountDown()
          }else if(resp.data.code !== 200){
            this.phoneSending = false;
            let msg = resp.data.msg ? resp.data.msg : resp.data.message;
            this.$message({
              message: msg,
              type: 'warning'
            });
          }
        }, (err) => {
          this.haveSendPhoneCode = true;
          this.phoneSending = false;
        })
      }
    },
    checkSendPhoneForm(){
      let isOK = true;
      let msg = check.checkUsername(this.forgetUserName);
      let phoneMsg = check.checkPhoneNumber(this.forgetUserPhone);
//检验账号
      if(msg){
        this.$message({
          message: msg,
          type: 'warning'
        });
        isOK = false
      }
      if(phoneMsg) {
        this.$message({
          message: phoneMsg,
          type: 'warning'
        });
        isOK = false
      }

      return isOK
    },
    verifyPhoneCode() {
      // this.phoneActive = 2;
      let params = {
        username: this.forgetUserName,
        numberType: 1,
        phoneOrEmail: this.forgetUserPhone,
        verifyCode: this.phoneUserCode,
        password: this.newPassWord,
        repeatPassword : this.repeatNewPassWord,
      };
      let isOK = this.checkVerifyPhoneForm();
      if(this.haveTestPhoneCode&&isOK) {
        this.haveTestPhoneCode = false;
        this.$api.post(this.$urls.USER.confirm, params, (resp) => {
          this.haveTestPhoneCode = true;
          if (resp.data.code === 200) {
            this.phoneActive = 2;
          }else if(resp.data.code !== 200){
            let msg = resp.data.msg ? resp.data.msg : resp.data.message;
            this.$message({
              message: msg,
              type: 'warning'
            });
          }
        }, (err) => {
          this.haveTestPhoneCode = true;
        })
      }
    },
    checkVerifyPhoneForm(){
      let isOK = true;
      // let phoneMsg = check.checkPhone(this.forgetUserPhone);
      let pwdMsg = check.checkConfirm(this.newPassWord,this.repeatNewPassWord);
// 校验手机
//       if(phoneMsg) {
//         this.$message({
//           message: phoneMsg,
//           type: 'warning'
//         });
//         isOK = false
//       }
//校验密码
      if(pwdMsg){
        this.$message({
          message: pwdMsg,
          type: 'warning'
        });
        isOK = false
      }
      if(this.phoneUserCode===''){
        this.$message({
          message: '请输入验证码',
          type: 'warning'
        });
        isOK = false
      }

      return isOK
    },

    sendEmailCode() {

      let params = {
        username: this.forgetUserName,
        numberType: 2,
        phoneOrEmail: this.forgetUserEmail,
      };
      let isOK = this.checkSendEmailForm();
      if(this.haveSendEmailCode&&isOK) {
        this.haveSendEmailCode = false;
        this.emailSending = true; // 再次发送按钮

        this.$api.post(this.$urls.USER.sendCode, params, (resp) => {
          this.haveSendEmailCode = true;

          if (resp.data.code === 200) {
            this.emailActive = 1;
            this.emailCountDown()
          }else if(resp.data.code !== 200){
            this.emailSending = false;
            let msg = resp.data.msg ? resp.data.msg : resp.data.message;
            this.$message({
              message: msg,
              type: 'warning'
            });
          }
        }, (err) => {
          this.haveSendPhoneCode = true;
          this.emailSending = false;
        })
      }

    },
    checkSendEmailForm(){
      let isOK = true;
      let msg = check.checkUsername(this.forgetUserName);
      let emailMsg = check.checkEmail(this.forgetUserEmail);
//检验账号
      if(msg){
        this.$message({
          message: msg,
          type: 'warning'
        });
        isOK = false
      }
      if(emailMsg) {
        this.$message({
          message: emailMsg,
          type: 'warning'
        });
        isOK = false
      }

      return isOK
    },
    verifyEmailCode() {
      // this.emailActive = 2;
      let params = {
        username: this.forgetUserName,
        numberType: 2,
        phoneOrEmail: this.forgetUserEmail,
        verifyCode: this.emailUserCode,
        password: this.newPassWord,
        repeatPassword : this.repeatNewPassWord,
      };
      let isOK = this.checkVerifyEmailForm();
      if(this.haveTestEmailCode&&isOK) {
        this.haveTestEmailCode = false;
        this.$api.post(this.$urls.USER.confirm, params, (resp) => {
          this.haveTestEmailCode = true;
          if (resp.data.code === 200) {
            this.emailActive = 2;
          }else if(resp.data.code !== 200){
            let msg = resp.data.msg ? resp.data.msg : resp.data.message;
            this.$message({
              message: msg,
              type: 'warning'
            });
          }
        }, (err) => {
          this.haveTestEmailCode = true;
        })
      }
    },
    checkVerifyEmailForm(){
      let isOK = true;
      let phoneMsg = check.checkEmail(this.forgetUserEmail);
      let pwdMsg = check.checkConfirm(this.newPassWord,this.repeatNewPassWord);
// 校验手机
      if(phoneMsg) {
        this.$message({
          message: phoneMsg,
          type: 'warning'
        });
        isOK = false
      }
//校验密码
      if(pwdMsg){
        this.$message({
          message: pwdMsg,
          type: 'warning'
        });
        isOK = false
      }
      if(this.emailUserCode===''){
        this.$message({
          message: '请输入验证码',
          type: 'warning'
        });
        isOK = false
      }

      return isOK
    },

    // showForgetPassword() {
    //   this.forgetPassword = true;
    //   this.activeName = 'first'
    // },
    phoneCountDown() {
      let _this = this;
      this.phoneSending = true;
      this.phoneTimer = setInterval(()=>{
        --_this.phoneCount;
        this.phoneBtnTips = '（' + _this.phoneCount + '秒）后重新发送';
        if(_this.phoneCount<0){
          this.phoneCountDownFinish()
        }

      },1000);
    },
    emailCountDown() {
      let _this = this;
      this.emailSending = true;
      this.emailTimer = setInterval(()=>{
        --_this.emailCount;
        this.emailBtnTips = '（' + _this.emailCount + '秒）后重新发送';
        if(_this.emailCount<0){
          this.emailCountDownFinish()
        }
      },1000);
    },

    emailCountDownFinish() {
      clearInterval(this.emailTimer);
      this.emailSending = false;
      this.emailCount = 60;
      this.emailBtnTips = '发送验证码'
    },
    phoneCountDownFinish() {
      clearInterval(this.phoneTimer);
      this.phoneSending = false;
      this.phoneCount = 60;
      this.phoneBtnTips = '发送验证码'
    },
    // 修改密码
    switchDialog() {
      this.$emit('forgetPasswordDialog');
    },
    handleClick(tab, event) {
      this.newPassWord = '';
      this.repeatNewPassWord = '';
      if(tab.name === 'third') {
        this.activeName = 'first';
        this.switchDialog();
        setTimeout(()=>{
          this.forgetPassword = false;
          window.open(this.customer_service_system_link);
        },800)

      }
    },
  },
  mounted() {

  }
};
</script>

<style scoped lang="scss">
  .step-wrap{
    padding-bottom:50px;
    .input-wrap{
      padding-top: 15px;
      .verify-warp{
        padding: 40px 100px 0;
        .complete-warp{
          padding: 45px 0;
          font-size: 18px;
          text-align: center;
          .tip{ margin-left: 25px }
        }
        .el-input{
          margin-bottom: 15px;
          .el-input__icon{
            background-image: url("./input-icon.png");
            background-repeat: no-repeat;
            background-position-x: left;
            background-size: 16px
          }
          .el-icon-search{ &:before{content: ''} }
          .icon-user{ background-position-y: 10px }
          .icon-email{ background-position-y: -31px }
          .icon-phone{ background-position-y: -66px }
          .icon-code{ background-position-y: -110px }
        }
        .phone-wrap .grid-content{
          padding-left: 15px ;
          height: 40px;
          line-height: 40px;
        }
        .button-wrap{
          text-align: center;
          padding-top: 20px;
          .button{ 
            width: 80%;
            height: 60px;
            background-color: #e2bf87;
            box-shadow: 0px 2px 5px 0px rgba(48, 48, 48, 0.5);
            border-radius: 6px;
            font-family: ArialMT;
            font-size: 20px;
            color: #ffffff;
          }
          .btn2{
            width: 120%;
            margin: 12px -10% 0;
            font-size:14px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/build902/components/common/forgetPassword/index.vue